import { getVitalFlagsFromScan, getStressLabel } from '../pages/MedicalScribe/Dashboard/mindvaultUtils';

// Entirely fictional records. Field names and derived flags match the live UI.
export const exampleChat = {
  session_id: 'tour-chat-1', created_at: '2026-01-08T10:00:00Z',
  emotions: ['Worried', 'Hopeful'], key_themes: ['Sleep routine', 'Work-related stress', 'Work-life balance'],
  risk_level: 'MEDIUM', risk_confidence: 0.86,
  risk_signals: ['Sleep disruption', 'Work-related stress'],
  session_summary: 'Example: Jordan describes an irregular sleep routine during a busy work week and would like to discuss ways to unwind.',
};
export const exampleConversation = [
  { role: 'user', content: 'Work has been busy and my sleep routine has been irregular this week.' },
  { role: 'assistant', content: 'What has your evening routine been like?' },
];
export const exampleScan = {
  created_at: '2026-01-08T09:00:00Z', heart_rate: 102, sbp: 138, dbp: 88,
  oxygen_saturation: 98, respiration_rate: 16, hr_variability: 110, stress_index: 260,
  activity: 4, sleep: 2, equilibrium: 4, metabolism: 3.5, health: 4, relaxation: 3,
};
export const exampleScans = [exampleScan, { ...exampleScan, created_at: '2026-01-06T09:00:00Z', heart_rate: 96, sleep: 3, relaxation: 4 }];
export const exampleAssessments = {
  phq9: [{ total_score: 6, severity_level: 'Mild', completed_at: '2026-01-08' }, { total_score: 8, severity_level: 'Mild', completed_at: '2026-01-01' }],
  gad7: [{ total_score: 7, severity_level: 'Mild', completed_at: '2026-01-08' }, { total_score: 9, severity_level: 'Mild', completed_at: '2026-01-01' }],
};
export const exampleListSummary = {
  linked: true, accessRestricted: false, vitalFlags: getVitalFlagsFromScan(exampleScan),
  stressLabel: getStressLabel(exampleScan.stress_index),
  chatRiskSignals: { HIGH: [], MEDIUM: exampleChat.risk_signals },
  chatCount: 8, scanCount: 12, appointmentsCount: 4,
};
export const exampleScanAverage = [exampleScan.activity, exampleScan.sleep, exampleScan.equilibrium, exampleScan.metabolism, exampleScan.health, exampleScan.relaxation].reduce((a, b) => a + b, 0) / 6;
